import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "offcanvas-body" }
const _hoisted_2 = ["innerHTML"]

import { useQuery } from "@tanstack/vue-query";
import { settingsRepo } from "@/di/repositories";


export default /*#__PURE__*/_defineComponent({
  __name: 'PrivacyPolicy',
  setup(__props) {

const { data: privacyPolicy, isPending: loading } = useQuery({
  queryKey: ["settings", "privacy-policy"],
  queryFn: () => settingsRepo.getPrivacyPolicy(),
  staleTime: Infinity,
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingContainer = _resolveComponent("LoadingContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(loading))
      ? (_openBlock(), _createBlock(_component_LoadingContainer, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", { innerHTML: _unref(privacyPolicy) }, null, 8, _hoisted_2)
  ]))
}
}

})